/* eslint-disable no-lone-blocks */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Title from "../extras/Title";
import { useDispatch, useSelector } from "react-redux";
import { getAdmin, logout, updateAdmin, updateAdminPassword } from "../../redux/slice/authSlice";
import Button from "../extras/Button";
import { adminProfile } from "../../redux/api";
import { useQuery } from "@tanstack/react-query";
import noImage1 from "../../../src/assets/images/noimage1.png"
import { permissionError } from "../../util/Alert";
import { IconPencil } from "@tabler/icons-react";

export const AdminProfile = () => {
  const dispatch = useDispatch();
  const hasPermission = useSelector((state) => state.auth.admin.flag)

  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [image, setImage] = useState([]);
  const [imagePath, setImagePath] = useState("");
  const [toggle, setToggle] = useState(false)

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [data, setData] = useState({});

  const { admin } = useSelector((state) => state.auth);


  useEffect(() => {

    dispatch(getAdmin())
  }, [])

    ;
  console.log("adminadmin", admin);

  useEffect(() => {
    setData(admin);
  }, [admin]);

  useEffect(() => {
    setName(data?.name);
    setEmail(data?.email);
    setImagePath(data?.image);
    setError({ name: "", email: "" });
  }, [data]);


  const handleUploadImage = (e) => {
    if (!hasPermission) return permissionError();
    setImage(e.target.files[0]);
    setImagePath(URL.createObjectURL(e.target.files[0]));
    setError((prevErrors) => ({
      ...prevErrors,
      image: "",
    }));
      const formData = new FormData();
      formData.append("image", e.target.files[0]);
      dispatch(updateAdmin(formData));
  };

  const handleChangePassword = () => {
    if (!hasPermission) return permissionError();
    if (
      !newPassword ||
      !confirmPassword ||
      newPassword !== confirmPassword ||
      !oldPassword
    ) {
      let error = {};
      if (!newPassword) error.newPassword = "New password is required !";
      if (!confirmPassword)
        error.confirmPassword = "Confirm password Is required !";
      if (newPassword !== confirmPassword)
        error.confirmPassword =
          "New password and confirm password doesn't match";
      if (!oldPassword) error.oldPassword = "Old password is required !";
      return setError({ ...error });
    } else {
      let data = {
        oldPass: oldPassword,
        confirmPass: confirmPassword,
        newPass: newPassword,
      };
      dispatch(updateAdminPassword(data));
    }
  };

  const handleEditName = () => {
    if (!hasPermission) return permissionError();
    if (!imagePath || !name || !email) {

      let error = {}
      if (!email) error.email = "Email is required"
      if (!name) error.name = "Name is required"
      if (!image || imagePath?.length < 0) error.image = "Image is required"
    } else {
      const formData = new FormData();
      formData.append("image", image);
      formData.append("name", name);
      formData.append("email", email);
      dispatch(updateAdmin(formData));
    }
  };

  const handlePrevious = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div className="profile-page payment-setting">
      <div className="card1">
        <div className="cardHeader p-3">
          <h5
            style={{
              fontWeight: "500",
              fontSize: "20px",
            }}
            className="m-0"
          >
            Profile Details
          </h5>
        </div>
        <div className="row" style={{ padding: "15px" }}>
          <div className="col-lg-6 col-sm-12 ">
            <div className="mb-4 ">
              <div className="withdrawal-box  profile-img d-flex flex-column align-items-center">
                <h6 className="text-start">Profile Avatar</h6>
                {/* <div className="position-relative">
                  <input
                    id="file-input"
                    type="file"
                    accept="image/*"
                    className="d-none"
                    onChange={(e) => handleUploadImage(e)}
                  />
                  <img
                    src={imagePath ? imagePath : Male}
                    alt="admin"
                    className="mx-auto p-1 border "
                    onError={(e) => {
                      e.target.src = male;
                    }}
                    style={{
                      width: 180,
                      height: 180,
                      objectFit: "cover",
                      display: "block",
                      borderRadius: "50%",
                    }}
                    onClick={() => handlePrevious(imagePath)}
                  />
                  {error?.image && <p className="errorMessage text-danger text-capitalize">{error?.image}</p>}
                  <div
                    className="position-absolute"
                    style={{ bottom: "-4%", right: "45%" }}
                  >
                    <div className="bg-theme"
                      style={{
                        // background: "rgb(31, 28, 48)",
                        borderRadius: 50,
                        height: 29,
                      }}
                    >
                      <label htmlFor="file-input">
                        <i
                          className="fa fa-camera d-flex justify-content-center  rounded-circle  p-2 cursorPointer m-0"
                          style={{
                            fontSize: 14,
                            color: "rgb(255, 255, 255)",
                            cursor: "pointer",
                            marginRight: "3px",
                          }}
                        />
                      </label>
                    </div>
                  </div>
                </div> */}

                <div style={{ paddingTop: "14px" }}>
                  <label for="image" onChange={handleUploadImage}>
                    <div className="avatar-img-icon">
                      <i class="fa-solid fa-camera d-flex justify-content-center  rounded-circle  p-2 cursorPointer"><IconPencil className="profile-edit-icon" /></i>
                      {/* <IconPencil className="profile-edit-icon"/> */}
                    </div>
                    <input
                      type="file"
                      name="image"
                      id="image"
                      style={{ display: "none" }}
                    />
                    {false ? (

                      <div className="image-loader"></div>) :
                      (<img
                        alt=""
                        src={imagePath}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = noImage1;
                        }}
                      />
                      )}
                  </label>
                  <h5 className="fw-semibold boxCenter mt-2">{data?.name}</h5>
                </div>
               
                    {/* <Button
                      onClick={handleEditName}
                      className={`text-end btn bg-theme text-white ml-2`}
                      text={`Upload Image`}
                    /> */}
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-sm-12">
            <div className="mb-4">
              <div className="withdrawal-box payment-box">
                <h6 className="mb-0">Edit Profile</h6>
                <div className="row">
                  <form>
                    <div className="row">
                      <div className="withdrawal-input">
                        <div className="mb-3">
                          <label
                            className="mb-2 text-gray ml-3"
                            style={{ fontSize: 15 }}
                          >
                            Name
                          </label>
                          <input
                            type="text"
                            placeholder="name"
                            className="form-control p-2"
                            value={name}
                            onChange={(e) => {
                              setName(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  name: "Name is required !",
                                });
                              } else {
                                return setError({
                                  ...error,
                                  name: "",
                                });
                              }
                            }}
                          />
                          {error.name && (
                            <p className="errorMessage text-capitalize text-danger">{error.name}</p>
                          )}
                        </div>
                      </div>
                      <div className="form-group  mr-4">
                        <div className="mb-2">
                          <label
                            className="mb-2 text-gray ml-3"
                            style={{ fontSize: 15 }}
                          >
                            Email
                          </label>
                          <input
                            type="email"
                            placeholder="email"
                            className="form-control p-2"
                            value={email}
                            onChange={(e) => {
                              setEmail(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  email: "Email is required !",
                                });
                              } else {
                                return setError({
                                  ...error,
                                  email: "",
                                });
                              }
                            }}
                          />
                        </div>
                        {error.email && (
                          <p className="errorMessage text-capitalize text-danger">{error.email}</p>
                        )}
                      </div>
                      <div className="col-12 d-flex mt-2 justify-content-end">
                        <Button
                          text={"Submit"}
                          type={"button"}
                          onClick={handleEditName}
                          newClass={"submit-btn"}
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>


          <div className="col-lg-6 col-sm-12">
            <div className="mb-4">
              <div className="withdrawal-box payment-box">
                <h6 className="mb-0">Change Password</h6>
                <div className="row">
                  <form>
                    <div className="row">
                      <div className="withdrawal-input">
                        <div className="mb-2">
                          <label className="mb-2 text-gray ml-3 font-weight-bold">
                            Old Password
                          </label>
                          <input
                            type="password"
                            className="form-control p-2"
                            placeholder="Old Password"
                            value={oldPassword}
                            onChange={(e) => {
                              setOldPassword(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  oldPassword: "Old password is required !",
                                });
                              } else {
                                return setError({
                                  ...error,
                                  oldPassword: "",
                                });
                              }
                            }}
                          />
                          {error.oldPassword && (
                            <p className="text-danger errorMessage text-capitalize">
                              {error.oldPassword}
                            </p>
                          )}
                        </div>
                        <div className="mb-2">
                          <label className="mb-2 text-gray ml-3 font-weight-bold">
                            New Password
                          </label>
                          <input
                            type="password"
                            className="form-control p-2"
                            placeholder="New Password"
                            value={newPassword}
                            onChange={(e) => {
                              setNewPassword(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  newPassword: "New password is required !",
                                });
                              } else {
                                return setError({
                                  ...error,
                                  newPassword: "",
                                });
                              }
                            }}
                          />
                          {error.newPassword && (
                            <p className="text-danger errorMessage text-capitalize">
                              {error.newPassword}
                            </p>
                          )}
                        </div>
                        <div className="mb-2 ">
                          <label className="mb-2 text-gray ml-3 font-weight-bold">
                            Confirm Password
                          </label>
                          <input
                            type="password"
                            className="form-control p-2"
                            placeholder="Confirm Password"
                            value={confirmPassword}
                            onChange={(e) => {
                              setConfirmPassword(e.target.value);
                              if (!e.target.value) {
                                return setError({
                                  ...error,
                                  confirmPassword:
                                    "Confirm password is required !",
                                });
                              } else {
                                return setError({
                                  ...error,
                                  confirmPassword: "",
                                });
                              }
                            }}
                          />
                          {error.confirmPassword && (
                            <p className="text-danger errorMessage text-capitalize">
                              {error.confirmPassword}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-12 d-flex mt-3 justify-content-end">
                        <Button
                          text={"Submit"}
                          type={"button"}
                          onClick={handleChangePassword}
                          newClass={"submit-btn"}
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>



          {/* <div className="col-lg-6 col-sm-12">
            <div className="mb-4">
              <div className="col-12">
                <div className="withdrawal-box payment-box">
                  <h6 className="mb-0">Edit Profile</h6>
                  {toggle ? (
                    <div className="card-body">
                      <h4 className="profile_box pb-2 my-3 text-center head-bg">
                        Password Settings
                      </h4>
                      <div className="col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-7 mx-auto">
                        <div className="form-group mt-4 ">
                          
                        </div>
                        <div className="form-group">
                          
                        </div>
                        <div className="form-group ">
                          
                        </div>

                        <div className="d-flex justify-content-end pt-4">
                          <Button
                            onClick={handleChangePassword}
                            text={`Submit`}
                            className={` text-white`}
                            style={{ backgroundColor: "#1ebc1e" }}
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="card-body">
                      <div className="col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-7 mx-auto my-5">
                        <div className="form-group  mr-4 mt-3">
                          <div className="mb-3">
                            <label
                              className="mb-2 text-gray ml-3"
                              style={{ fontSize: 15 }}
                            >
                              Name
                            </label>
                            <input
                              type="text"
                              placeholder="name"
                              className="form-control p-2"
                              value={name}
                              onChange={(e) => {
                                setName(e.target.value);
                                if (!e.target.value) {
                                  return setError({
                                    ...error,
                                    name: "Name is required !",
                                  });
                                } else {
                                  return setError({
                                    ...error,
                                    name: "",
                                  });
                                }
                              }}
                            />
                            {error.name && (
                              <p className="errorMessage text-capitalize text-danger">{error.name}</p>
                            )}
                          </div>
                        </div>
                        <div className="form-group  mr-4">
                          <div className="mb-2">
                            <label
                              className="mb-2 text-gray ml-3"
                              style={{ fontSize: 15 }}
                            >
                              Email
                            </label>
                            <input
                              type="email"
                              placeholder="email"
                              className="form-control p-2"
                              value={email}
                              onChange={(e) => {
                                setEmail(e.target.value);
                                if (!e.target.value) {
                                  return setError({
                                    ...error,
                                    email: "Email is required !",
                                  });
                                } else {
                                  return setError({
                                    ...error,
                                    email: "",
                                  });
                                }
                              }}
                            />
                          </div>
                          {error.email && (
                            <p className="errorMessage text-capitalize text-danger">{error.email}</p>
                          )}
                        </div>
                        <div className="d-flex justify-content-end pt-4">
                          <Button
                            onClick={handleEditName}
                            text={`Submit`}
                            className={` text-white`}
                            style={{ backgroundColor: "#1ebc1e" }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

